module.exports = __webpack_public_path__ + "static/news-11-banqiao-fce9741d3586967991f16886df0f22ca.png";